import { render, staticRenderFns } from "./NewRegistrations.vue?vue&type=template&id=5c3cb1d3&"
import script from "./NewRegistrations.vue?vue&type=script&lang=js&"
export * from "./NewRegistrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports